
export default {
  props: {
    currentStep: {
      type: Number,
      default: 200,
      required: true
    },
    totalSteps: {
      type: Number,
      default: 500,
      required: true
    }
  }
};
